<template>
    <div
        class="md toggle-aside"
        :class="[state? 'is-active': '']"
    >
        <a
            :title="title"
            v-if="showBtn"
            v-html="html"
            
            @click.prevent="changeState"
        ></a>
    </div>
</template>

<script>
    export default {
        props: {
            state: {
                type: Boolean,
                required: false,
                default: true,
            },
            title: {
                type: String,
                required: false,
                default: '開啟/收合',
            },
            html: {
                type: String,
                required: false,
                default: '',
            },
            showBtn: {
                type: Boolean,
                required: false,
                default: true,
            },
        },
        methods: {
            changeState: function(){
                this.$emit('sendEvent', 'changeState');
            }
        }
    }
</script>

<style scoped lang="scss">

    .md.toggle-aside::v-deep {

        .lo.extend & {
            $size: 30px;
            
            z-index: 1;

            a {
                position: absolute;
                top: $interval-m;
                right: $interval-s;
                opacity: $opacity-l;
                cursor: pointer;

                &:hover {
                    opacity: 1;
                }

                &::after {
                    content: '\e5cd';
                    @extend %font-pseudo;
                    display: block;
                    width: $size;
                    height: $size;
                    text-align: center;
                    line-height: $size;
                    font-size: $font-size-xl;
                    transition: $transition;

                    @include media('mobile') {
                        font-size: $font-size-xxxl;
                    }
                }
            }
        }

        .lo.mobile & {
            position: absolute;
            left: 100%;
            top: 0;

            a {
                $size: 34px;

                display: block;
                position: relative;
                width: $mobileBtn_w;
                height: $mobileBtn_w;
                color: $major-color;
                cursor: pointer;

                &:hover {
                    color: $white;

                    @include media('mobile') {
                        color: $major-color;
                    }

                    &::before {
                        background-color: $major-color;

                        @include media('mobile') {
                            background-color: transparent;
                        }
                    }
                }

                &::before, &::after {
                    position: absolute;
                    top: ($mobileBtn_w - $size) / 2;
                    left: ($mobileBtn_w - $size) / 2;
                    width: $size;
                    height: $size;
                    line-height: $size;
                    transition: $transition;
                }

                &::before {
                    content: $content;
                    border-radius: 100%;
                }

                &::after {
                    @extend %font-pseudo;
                    content: '\e5d2';
                    font-size: $font-size-xxl;
                    text-align: center;
                }
            }
        }

        .lo.footer & {
            position: absolute;
            right: 100%;
            top: 0;

            a {
                $mobileBtn_w: 49px;
                $size: 34px;

                display: block;
                position: relative;
                width: $mobileBtn_w;
                height: $mobileBtn_w;
                color: $major-color;
                cursor: pointer;
                z-index: 1;

                &:hover {
                    color: $white;

                    @include media('mobile') {
                        color: $major-color;
                    }

                    &::before {
                        background-color: $major-color;

                        @include media('mobile') {
                            background-color: transparent;
                        }
                    }
                }

                &::before, &::after {
                    position: absolute;
                    top: ($mobileBtn_w - $size) / 2;
                    left: ($mobileBtn_w - $size) / 2;
                    width: $size;
                    height: $size;
                    line-height: $size;
                    transition: $transition;
                }

                &::before {
                    content: $content;
                    border-radius: 100%;
                }

                &::after {
                    @extend %font-pseudo;
                    content: '\e5d2';
                    font-size: $font-size-xxl;
                    text-align: center;
                }
            }
        }

        .lo.aside & {
            $mobileSize: 42px;

            display: none;

            @include media('mobile') {
                display: block;
                position: fixed;
                right: $interval-m;
                bottom: $interval-m;
                z-index: 7;
            }

            &.is-active {

                a {

                    &::before {
                        content: '\e5cd';
                    }
                }
            }

            a {
                display: block;
                cursor: pointer;

                &::before {
                    display: block;
                    @extend %font-pseudo;
                    content: '\e5d2';
                    text-align: center;
                    width: $mobileSize;
                    height: $mobileSize;
                    line-height: $mobileSize;
                    font-size: $font-size-xxl;
                    border-radius: $mobileSize;
                    background: $major-color;
                    color: $white;
                    box-shadow: $box-shadow;
                }
            }
        }
    }
</style>
